<template>
    <div class="main-container confirmation">
        <div class="people-container p-5">
            <h2>Confirmation</h2>
            <p>
                Your order has been placed. Your transaction number is: <strong> {{ transaction_id }} </strong>
            </p>
            <p>Please check your email for a receipt.</p>
        </div>
        <div class="flex justify-between items-center">
            <a href="/" class="button primary">Return Home</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConfirmationView",
    components: {},
    data() {
        return {
            transaction_id: localStorage.getItem("people_transaction_id"),
        };
    },
    mounted() {
        this.emitter.emit("updateProgress", { step: 7 });

        localStorage.removeItem("people_order");
        localStorage.removeItem("people_save_for_later");
        localStorage.removeItem("people_ad_type");
        localStorage.removeItem("people_add_on_accounts");
        localStorage.removeItem("people_order_item");
        localStorage.removeItem("people_transaction_id");
        localStorage.removeItem("people_channels");
        localStorage.removeItem("people_token");
        sessionStorage.removeItem("people_billing");
    },
};
</script>

<style>
.confirmation p {
    font-size: 16px;
    line-height: 1.5;
    margin-bottom: 12px;
}

.confirmation p:last-child {
    margin-bottom: 0;
}
</style>
